import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { Trans } from 'helpers/i18n';
import Link from 'components/link';
import Row, { Col } from 'components/row';

import { emailDomik } from 'src-sites/domik/config';

import { renderLinkToMain } from './doc-user-agreement-site';

import 'styles/domik/section-terms/_page-terms.scss';

const bemClasses = new Bem('pageTerms');

export default class DocTermsUseMaterials extends Component {
  static propTypes = {
    blockRef: PropTypes.func,
    blockId: PropTypes.string
  };

  render() {
    const { blockRef, blockId } = this.props;
    const mailDomik = (
      <Link
        {...bemClasses('link', 'mail')}
        href={`mailto:${emailDomik}`}
        title={emailDomik}
        external
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text', 'underline')} children={emailDomik} />
        </span>
      </Link>
    );

    return (
      <div
        {...bemClasses('section', 'termsUseMaterials')}
        ref={blockRef}
        id={blockId}
      >
        <Trans lang="ru">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Правила перепечатки авторских материалов портала Domik.ua" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p children="Авторские права на все материалы, публикуемые на портале «Domik.ua», принадлежат порталу «Domik.ua». Исключения составляют материалы, перепечатанные из других информационных ресурсов, со ссылкой на источник." />
            <p children="Перепечатка, воспроизведение и использование материалов портала «Domik.ua» интернет-ресурсами разрешается исключительно в случае выполнения следующих правил:" />
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>При полном или частичном использовании новости или статьи портала Domik.ua, обязательно наличие в первом или втором абзаце текста фразы «… как пишет (сообщает, по данным и т. д.) Domik.ua». При этом, название «Domik.ua» должно быть активной гиперссылкой на страницу месторасположения новости на портале Domik.ua.</span>
              <div {...bemClasses('text')}>
                <p>
                  При перепечатке авторских материалов портала Domik.ua (такие материалы помечаются подписью «По материалам: {renderLinkToMain.call(this, 'Domik.ua-недвижимость')}» и иконкой Domik.ua), текст статьи должен обязательно начинаться с фразы «По материалам Domik.ua» или «Источник: Domik.ua», после которой следует непосредственно текст новости и ссылка на портал.
                </p>
                <p children="В перепечатываемых материалах использование тега noindex, атрибута nofollow запрещено." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>При использовании аналитических материалов, содержащих эксклюзивные расчеты тех или иных показателей, обязательной является ссылка на портал Domik.ua как автора данных. В таком случае, обязательно также наличие фразы в начале новости «По подсчетам портала Domik.ua …», а также наличие в первом или втором абзаце текста фразы «по данным (подсчетам и т. д.) портала Domik.ua». При этом, название «Domik.ua» должно быть гиперссылкой на страницу месторасположения новости на портале Domik.ua.</span>
              <div {...bemClasses('text')}>
                <p>Для использования материалов портала Domik.ua способами, выходящими за рамки, установленные данной лицензией, необходимо письменное разрешение редакции. Связаться с нами для решения данного вопроса можно по адресу: {mailDomik}.</p>
                <p children="Нарушение этих правил будет рассматриваться, как нарушение действующего законодательства Украины. В данном случае, администрация портала «Domik.ua» оставляет за собой право на защиту авторских прав в арбитражах поисковых систем и в установленном законодательством Украины судебном порядке." />
              </div>
            </li>
          </ol>
        </Trans>
        <Trans lang="ua">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Правила передруку авторських матеріалів порталу Domik.ua" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p children="Авторські права на всі матеріали, що публікуються на порталі «Domik.ua», належать порталу «Domik.ua». Винятки становлять матеріали, передруковані з інших інформаційних ресурсів, з посиланням на джерело." />
            <p children="Передрук, відтворення і використання матеріалів порталу «Domik.ua» інтернет-ресурсами дозволяється виключно в разі виконання наступних правил:" />
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>При повному або частковому використанні новин або статті порталу Domik.ua, обов'язкова наявність в першому або другому абзаці тексту фрази «... як пише (повідомляє, за даними і т. ін.) Domik.ua». При цьому, назва «Domik.ua» має бути активним гіперпосиланням на сторінку розташування новин на порталі Domik.ua.</span>
              <div {...bemClasses('text')}>
                <p>
                  У разі передруку авторських матеріалів порталу Domik.ua (такі матеріали позначаються підписом «За матеріалами: {renderLinkToMain.call(this, 'Domik.ua-нерухомість')}» та іконкою Domik.ua), текст статті повинен обов'язково починатися з фрази «За матеріалами Domik.ua» або «Джерело: Domik.ua», після якої слідує безпосередньо текст новин та посилання на портал.
                </p>
                <p children="У передрукованих матеріалах використання тега noindex, атрибута nofollow заборонено." />
              </div>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text')}>При використанні аналітичних матеріалів, що містять ексклюзивні розрахунки тих чи інших показників, обов'язковою є посилання на портал Domik.ua як автора даних. В такому випадку, обов'язково також наявність фрази на початку новини «За підрахунками порталу Domik.ua ...», а також наявність у першому або другому абзаці тексту фрази «за даними (підрахунками і т. ін. ) Порталу Domik.ua». При цьому, назва «Domik.ua» має бути гіперпосиланням на сторінку розташування новини на порталі Domik.ua.</span>
              <div {...bemClasses('text')}>
                <p>Для використання матеріалів порталу Domik.ua способами, що виходять за рамки, встановлені цією ліцензією, необхідний письмовий дозвіл редакції. Зв'язатися з нами для вирішення даного питання можна за адресою: {mailDomik}.</p>
                <p children="Порушення цих правил буде розглядатися, як порушення чинного законодавства України. В даному випадку, адміністрація порталу «Domik.ua» залишає за собою право на захист авторських прав у арбітражах пошукових систем і в установленому законодавством України судовому порядку." />
              </div>
            </li>
          </ol>
        </Trans>
      </div>
    );
  }
}
